//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      currentURL: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  computed: {
    // link() {
    //   return process.env.SITE_URL + this.$route.path;
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.currentURL = window.location.href;
    });
  },
};
